import { TextArea as SemanticTextArea } from 'semantic-ui-react';

export { TextAreaProps } from 'semantic-ui-react';

export const TextArea: typeof SemanticTextArea = SemanticTextArea;

export default TextArea;
